import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

try {

	const googleReviewsSwiper = new Swiper('.google-reviews-swiper', {
		// Optional parameters
		//direction: 'vertical',
		modules: [Navigation],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 20,
		breakpoints: {
			992:{
				slidesPerView: 4,
			},
			576:{
				slidesPerView: 2,
			}
		},
		autoHeight: true, // Make slides equal height
		// autoplay: {
		// 	delay: 10000,
		// },
		// Navigation arrows
		navigation: {
			nextEl: '.google-reviews-swiper-button-next',
			prevEl: '.google-reviews-swiper-button-prev',
		},
	});

	const productReviewsSwiper = new Swiper('.product-reviews-swiper', {
		// Optional parameters
		//direction: 'vertical',
		modules: [Navigation],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 20,
		breakpoints: {
			992:{
				slidesPerView: 4,
			},
			576:{
				slidesPerView: 2,
			}
		},
		autoHeight: true, // Make slides equal height
		// autoplay: {
		// 	delay: 10000,
		// },
		// Navigation arrows
		navigation: {
			nextEl: '.product-reviews-swiper-button-next',
			prevEl: '.product-reviews-swiper-button-prev',
		},
	});


	// Just enclosing this in a try/catch block to prevent errors on other pages
	try {
		document.querySelectorAll('.related-products-slider li.product').forEach(li => li.classList.add('swiper-slide'));
		document.querySelector('.related-products-slider ul.products').classList.add('swiper-wrapper');
		document.querySelector('.related-products-slider ul.products').classList.remove('columns-4');
		// Related Products Slider
		
		var relatedSwiper = new Swiper('.related-products-slider', {
			// Optional parameters
			//direction: 'vertical',
			modules: [Navigation],
			loop: true,
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				992:{
					slidesPerView: 4,
				},
				576:{
					slidesPerView: 2,
				}
			},
			autoHeight: false, // Make slides equal height

			// Navigation arrows
			navigation: {
				nextEl: '.related-products-swiper-button-next',
				prevEl: '.related-products-swiper-button-prev',
			},
		});
	}
	catch(e) {
		;
	}


}
catch(e) {
	;
}
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}


// Read more button on product archive description:
document.addEventListener("DOMContentLoaded", ()=>{
	console.info('Read More activated');
	const container = document.querySelector('.woocommerce_archive_top_description.compressed');
	if(!container) {
		return;
	}
	const button = container.querySelector('.product_archive_read_more a');
	if(!button) {
		return;
	}

	button.addEventListener('click', (e) => {
		e.preventDefault();
		container.classList.remove('compressed');
		button.style.display = "none";
	})
});